module.exports = __webpack_public_path__ + "static/img/product-poster-4.d72a895c.png";